import { DateTime } from "luxon";
import { GetServerSideProps } from "next";
import Head from "next/head";
import { MenuId } from "../components/Header";
import Layout from "../components/Layout";
import PublicSearch from "../components/PublicSearch";
import { getJWTTokenFromUser, getUserInformation } from "../lib/data";
import { RusContextProps, RusAuthProps, SearchJson, Video } from "../lib/definitions";
import styles from './new-video-search.module.scss'
import {Text} from '@mantine/core'
import { sanitizeVideo } from "../lib/utils";
import EmailSignupBanner from "../components/EmailSignupBanner";
import Link from "next/link";
import { getClerkHeader } from "../lib/common";
import { getAuth } from '@clerk/nextjs/server';

type Data = {
    videos : Video [],
    dateProcessed: string,
    count: number,
    pinnedVideo: Video | null
      }
      
export default function NewVideoSearch (props: {data:Data} & RusContextProps & RusAuthProps)
{
    return (
        <Layout menuId={MenuId.online}>



        <Head>
            <title>Video search</title>
            <meta name="description" content="Some 500 art videos, focussing on portrait and figure drawing and painting, searchable by pose, material, subject type and more."></meta>
        </Head>
        <div className = {styles.mainContent}>
        <h1>Video search</h1>
        <Text mb='sm'>We have hundreds of art tutorial videos, ranging from the weekly sessions we&rsquo;ve been running since 2020, to special sessions from artists such as Lizet Dingemans, Luca Indraccolo, Cornelia Hernes and David Shevlino.</Text>
        <Text mb='lg'>You can browse them, or search by artist, material, subject matter, pose type and so on. Not sure where to start? Check out our <Link href='/playlists'>curated playlists</Link>.</Text>




        <PublicSearch searchType="video" {...props}/>
        </div>
        <EmailSignupBanner/>
        </Layout>
        );
        }

        export const getServerSideProps: GetServerSideProps<{ data: Data }> = async (context) => {

            // get the pinned video first time it's loaded too

            //let dtFrom = DateTime.now().toUTC().minus({hour:1}).startOf('minute');
            //let dtTo = dtFrom.plus({day:14});
        
            let dtNow = DateTime.now().toUTC();
            const { getToken } = getAuth(context.req);
            const clerkToken = await getToken();


            let search : SearchJson =
            {
                Count: 25,
                Offset: 0
            }
                              
            let json = encodeURIComponent(JSON.stringify(search, (_, v) => { if (v != null) return v; }));
        
            let user = await getUserInformation(context.req);

            let token;
        
            if (user.subscribed)
            {
                token = await getJWTTokenFromUser(user);
            }
        
            let options = { 
                method: 'GET',  cache: "no-store" as RequestCache,
                 headers: {... token?{'auth-token': token}:{}, ...getClerkHeader(clerkToken)} as HeadersInit
            };

        
            let url = process.env.ADMIN_ROUTE + '/videosearch?json=' + json;
        
            let at2 =  await fetch(url, options);

            let j = (await at2.json());

            let vids = j.videos as Video [];

            let at3 =  await fetch( process.env.ADMIN_ROUTE + '/pinnedvideo', options);
            let pinned = (await at3.json()) as (Video | null);

            if (!pinned!.id)
            {
                pinned = null;
            }
            else
            {
                sanitizeVideo(pinned!, user);
            }
                    
            let count : number = j.count;
 
            return {
              props: {
                data : {
                videos: vids,
                count: count,
                pinnedVideo: pinned,
                dateProcessed: dtNow.toISO()
                }
              },
            }
          }
        
        